import {Injectable} from '@angular/core';
import {CanActivate, CanActivateChild, Router} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import * as Rx from 'rxjs';
import {JwtHelper} from 'angular2-jwt';
import {StoreService} from '../store/store.service';

// import {RegistrationUser} from '../public/auth/auth.component';
// import {DynamoDBService} from './ddb.service';
// import {AwsUtil} from './aws.service';

declare const AWSCognito: any;
declare const AWS: any;

export interface CognitoCallback {
    cognitoCallback(message: string, result: any): void;
}

export interface LoggedInCallback {
    isLoggedIn(message: string, loggedIn: boolean): void;
}

export interface Callback {
    callback(): void;

    callbackWithParam(result: any): void;
}

@Injectable()
export class CognitoAuthService implements CanActivate, CanActivateChild {

    public static _REGION = 'us-east-1';
    public static _IDENTITY_POOL_ID = 'us-east-1:4330a1f4-7bfc-4e49-8ca1-55541c4110b5';
    public static _USER_POOL_ID = 'us-east-1_FkfT0BdJ2';
    public static _CLIENT_ID = '6uj599r8i9lke7n9ndmup1lok9';

    public static _POOL_DATA = {
        UserPoolId: CognitoAuthService._USER_POOL_ID,
        ClientId: CognitoAuthService._CLIENT_ID
    };

    public static getAwsCognito(): any {
        return AWSCognito;
    }

    constructor(private router: Router, private jwtHelper: JwtHelper, private store: StoreService) {
    }

    getUserPool() {
        return new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(CognitoAuthService._POOL_DATA);
    }

    getCurrentUser() {
        return this.getUserPool().getCurrentUser();
    }

    getCognitoIdentity(): string {
        return AWS.config.credentials.identityId;
    }


    // Old way without using Promise
    getAccessToken(callback: Callback): void {
        if (callback == null) {
            throw('CognitoUtil: callback in getAccessToken is null...returning');
        }
        if (this.getCurrentUser() != null) {
            this.getCurrentUser().getSession(function (err, session) {
                if (err) {
                    // console.log('CognitoUtil: Can't set the credentials:' + err);
                    callback.callbackWithParam(null);
                } else {
                    if (session.isValid()) {
                        callback.callbackWithParam(session.getAccessToken().getJwtToken());
                    }
                }
            });
        } else {
            callback.callbackWithParam(null);
        }
    }

    // New way using Promise
    getAccessTokenPromise(): Promise<any> {

        return new Promise((resolve, reject) => {

            if (this.getCurrentUser() != null) {

                this.getCurrentUser().getSession(function (err, session) {

                    if (err) {

                        console.log('ERROR while getSession() in getAccessTokenPromise()');

                        reject(err);
                    } else {

                        console.log('NO ERROR while getSession() in getAccessTokenPromise()');

                        if (session.isValid()) {

                            console.log('Session is VALID in getAccessTokenPromise()');

                            resolve(session.getAccessToken().getJwtToken());
                        } else {

                            console.log('Session NOT VALID in getAccessTokenPromise()');

                            resolve(null);
                        }
                    }
                });
            } else {

                console.log('NO CURRENT USER in getAccessTokenPromise()');

                resolve(null);
            }
        });

    }


    // Old way without using Promise
    getIdToken(callback: Callback): void {
        if (callback == null) {
            throw('CognitoUtil: callback in getIdToken is null...returning');
        }

        // TODO: First try to get the IdToken from localStorage. If it's expired or null, get it from Cognito

        if (this.getCurrentUser() != null) {

            this.getCurrentUser().getSession(function (err, session) {

                // console.log(session);

                if (err) {
                    // console.log('CognitoUtil: Can't set the credentials:' + err);
                    callback.callbackWithParam(null);
                } else {
                    if (session.isValid()) {

                        // TODO: Save token to localStorage

                        callback.callbackWithParam(session.getIdToken().getJwtToken());
                    } else {
                        // console.log('CognitoUtil: Got the id token, but the session isn't valid');
                    }
                }
            });
        } else {
            callback.callbackWithParam(null);
        }
    }

    // New way using Promise
    getIdTokenPromise(): Promise<any> {

        return new Promise((resolve, reject) => {

            if (this.getCurrentUser() != null) {

                this.getCurrentUser().getSession(function (err, session) {

                    if (err) {

                        // console.log('ERROR while getSession() in getIdTokenPromise()');

                        reject(err);
                    } else {

                        // console.log('NO ERROR while getSession() in getIdTokenPromise()');

                        if (session.isValid()) {

                            // console.log('Session is VALID in getIdTokenPromise()');

                            resolve(session.getIdToken().getJwtToken());
                        } else {

                            // console.log('Session NOT VALID in getIdTokenPromise()');

                            resolve(null);
                        }
                    }
                });
            } else {

                // console.log('NO CURRENT USER in getIdTokenPromise()');

                resolve(null);
            }
        });

    }

    getRefreshToken(callback: Callback): void {
        if (callback == null) {
            throw('CognitoUtil: callback in getRefreshToken is null...returning');
        }
        if (this.getCurrentUser() != null) {

            this.getCurrentUser().getSession(function (err, session) {
                if (err) {
                    // console.log('CognitoUtil: Can't set the credentials:' + err);
                    callback.callbackWithParam(null);
                } else {
                    if (session.isValid()) {
                        callback.callbackWithParam(session.getRefreshToken());
                    }
                }
            });
        } else {
            callback.callbackWithParam(null);
        }
    }

    refresh(): void {
        this.getCurrentUser().getSession(function (err, session) {
            if (err) {
                // console.log('CognitoUtil: Can't set the credentials:' + err);
            } else {
                if (session.isValid()) {
                    // console.log('CognitoUtil: refresshed successfully');
                } else {
                    // console.log('CognitoUtil: refresshed but session is still not valid');
                }
            }
        });
    }

    decodeToken(token: string) {
        return this.jwtHelper.decodeToken(token);
    }

    // XXX: Looks like we don't really need these operations!  The SDK manages these operations for you - Wow!
    saveTokens() {
    }

    retrieveTokens() {
    }

    /*
     }

     @Injectable()
     export class UserRegistrationService {

     constructor(@Inject(CognitoAuthService) public cognitoUtil:CognitoAuthService) {

     }
     */

    /*
     //// Not needed currently
     register(user:RegistrationUser, callback:CognitoCallback):void {
     // console.log('UserRegistrationService: user is ' + user);

     let attributeList = [];

     let dataEmail = {
     Name: 'email',
     Value: user.email
     };
     let dataNickname = {
     Name: 'nickname',
     Value: user.name
     };
     attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataEmail));
     attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataNickname));

     this.getUserPool().signUp(user.email, user.password, attributeList, null, function (err, result) {
     if (err) {
     callback.cognitoCallback(err.message, null);
     } else {
     // console.log('UserRegistrationService: registered user is ' + result);
     callback.cognitoCallback(null, result);
     }
     });

     }
     */
    confirmRegistration(username: string, confirmationCode: string, callback: CognitoCallback): void {

        let userData = {
            Username: username,
            Pool: this.getUserPool()
        };

        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.confirmRegistration(confirmationCode, true, function (err, result) {
            if (err) {
                callback.cognitoCallback(err.message, null);
            } else {
                callback.cognitoCallback(null, result);
            }
        });
    }

    resendCode(username: string, callback: CognitoCallback): void {
        let userData = {
            Username: username,
            Pool: this.getUserPool()
        };

        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.resendConfirmationCode(function (err, result) {
            if (err) {
                callback.cognitoCallback(err.message, null);
            } else {
                callback.cognitoCallback(null, result);
            }
        });
    }

    /*
     }

     @Injectable()
     export class UserLoginService {

     // constructor(public ddb:DynamoDBService, public cognitoUtil:CognitoUtil) {
     // }
     constructor(public cognitoUtil:CognitoAuthService) {
     }
     */
    authenticate(username: string, password: string, callback: CognitoCallback) {
        const self = this;

        // console.log('UserLoginService: starting the authentication');
        // Need to provide placeholder keys unless unauthorised user access is enabled for user pool
        AWSCognito.config.update({accessKeyId: 'anything', secretAccessKey: 'anything'});

        let authenticationData = {
            Username: username,
            Password: password,
        };
        let authenticationDetails = new AWSCognito.CognitoIdentityServiceProvider.AuthenticationDetails(authenticationData);

        let userData = {
            Username: username,
            Pool: this.getUserPool()
        };

        // console.log('UserLoginService: Params set...Authenticating the user');
        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
        // console.log('UserLoginService: config is ' + AWS.config);
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function (session) {

                // console.log('session =', session);
                const idToken = self.jwtHelper.decodeToken(session.getIdToken().getJwtToken());
                // console.log('Decoded token: ', idToken);

                // Add the User's Id Token to the Cognito credentials login map.
                AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: CognitoAuthService._IDENTITY_POOL_ID,
                    Logins: {
                        'cognito-idp.us-east-1.amazonaws.com/us-east-1_PGSbCVZ7S': session.getIdToken().getJwtToken()
                    }
                });

                // console.log('UserLoginService: set the AWS credentials - ' + JSON.stringify(AWS.config.credentials));
                // console.log('UserLoginService: set the AWSCognito credentials - ' + JSON.stringify(AWSCognito.config.credentials));
                callback.cognitoCallback(null, session);
            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            },
            newPasswordRequired: function (userAttributes, requiredAttributes) {

                // TODO: route the user to change temporary password screen

                // clever hack for now: pass the same password to the complete challenge method
                cognitoUser.completeNewPasswordChallenge(password, null, this);
            }
        });
    }

    forgotPassword(username: string, callback: CognitoCallback) {
        let userData = {
            Username: username,
            Pool: this.getUserPool()
        };

        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.forgotPassword({
            onSuccess: function (result) {
                callback.cognitoCallback(null, null);
            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            },
            inputVerificationCode() {
                callback.cognitoCallback(null, null);
            }
        });
    }

    changePassword(oldPassword: string, newPassword: string, callback: CognitoCallback) {
        let cognitoUser = this.getCurrentUser();

        // console.log('cognitoUser = ', cognitoUser);

        if (cognitoUser != null) {
            cognitoUser.getSession(function (err, session) {

                // console.log('session = ', session);

                if (err) {
                    // console.log('UserLoginService: Couldn't get the session: ' + err, err.stack);
                    callback.cognitoCallback(err, false);
                    // return false;
                } else {
                    if (session.isValid()) {
                        cognitoUser.changePassword(oldPassword, newPassword, function (e, result) {
                            if (e) {
                                // console.log('changePassword error');
                                callback.cognitoCallback(e.message, false);
                            }
                            callback.cognitoCallback(null, result);
                        });
                    }
                }
            });
        } else {
            // console.log('UserLoginService: can't retrieve the current user');
            callback.cognitoCallback('Can\'t retrieve the CurrentUser', false);
            // return false;
        }
    }

    confirmNewPassword(email: string, verificationCode: string, password: string, callback: CognitoCallback) {
        let userData = {
            Username: email,
            Pool: this.getUserPool()
        };

        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.confirmPassword(verificationCode, password, {
            onSuccess: function (result) {
                callback.cognitoCallback(null, result);
            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            }
        });
    }

    signOut() {
        this.store.purge();
        // this.location.replaceState('/');
        // console.log('alerts in store after purge = ');
        // console.log(this.store.get('alerts'));

        // console.log('UserLoginService: Logging out');
        // this.ddb.writeLogEntry('signOut');

        this.getCurrentUser().signOut();

    }

    isAuthenticated(callback: LoggedInCallback): void {
        if (callback == null) {
            throw('UserLoginService: Callback in isAuthenticated() cannot be null');
        }

        // TODO: Retrieve tokens from localStorage and check isExpired. If isExpired or null, then get it from Cognito.

        let cognitoUser = this.getCurrentUser();

        if (cognitoUser != null) {
            cognitoUser.getSession(function (err, session) {

                console.log('session = ', session);

                if (err) {
                    console.log('UserLoginService: Could not get the session: ' + err, err.stack);
                    callback.isLoggedIn(err, false);
                    // return false;
                } else {
                    console.log('UserLoginService: Session is ' + session.isValid());
                    callback.isLoggedIn(err, session.isValid());
                    // return session.isValid();
                }
            });
        } else {
            // console.log('UserLoginService: can't retrieve the current user');
            callback.isLoggedIn('Cannot retrieve the CurrentUser', false);
            // return false;
        }
    }

    /*
     }

     @Injectable()
     export class UserParametersService {

     constructor(public cognitoUtil:CognitoAuthService) {
     }
     */
    getParameters(callback: Callback) {
        let cognitoUser = this.getCurrentUser();

        if (cognitoUser != null) {
            cognitoUser.getSession(function (err, session) {
                if (err) {
                    // console.log('UserParametersService: Couldn't retrieve the user');
                } else {
                    cognitoUser.getUserAttributes(function (e, result) {
                        if (e) {
                            // console.log('UserParametersService: in getParameters: ' + err);
                        } else {
                            callback.callbackWithParam(result);
                        }
                    });
                }

            });
        } else {
            callback.callbackWithParam(null);
        }
    }


    redirectToSignInPage() {
        const self = this;
        this.router.navigate(['sign-in']);

        // window.location.replace('/#/sign-in');
        // window.location.reload(true);
    }

    canActivate(): Observable<boolean> {

        let self = this;

        return Rx.Observable.create(function (observer) {
            self.isAuthenticated({
                isLoggedIn: function (message, loggedIn) {
                    console.log('isLoggedIn() called by isAuthenticated()');
                    observer.next(loggedIn);
                    observer.complete();
                }
            });

        });
    }

    canActivateChild(): Observable<boolean> {

        let self = this;

        return Rx.Observable.create(function (observer) {

            self.isAuthenticated({
                isLoggedIn: function (message, loggedIn) {
                    if (loggedIn) {
                        console.log('user is logged in');
                        observer.next(loggedIn);
                        observer.complete();
                        return true;
                    } else {
                        // console.log('redirecting to sign-in');
                        self.redirectToSignInPage();
                        return false;
                    }
                }
            });
        });

        /*
         const isAuth = this.isAuthenticated({
         isLoggedIn: function(message, loggedIn) {
         // console.log('isLoggedIn() called');
         return loggedIn;
         }
         });

         // console.log('isAuth = ', isAuth);

         if (!isAuth) {
         this.redirectToSignInPage();
         }

         return isAuth;
         */
    }

    /*
     canActivateChild() {
     // console.log('checking child route access using canActivateChild');
     return true;
     }
     */

}



// WEBPACK FOOTER //
// /app/src/app/shared/auth/cognito.service.ts